export const generalConstants = {
    // Loading recipients
    LOAD_STUDENT_STATUS_REQUEST: 'LOAD_STUDENT_STATUS_REQUEST',
    LOAD_STUDENT_STATUS_SUCCESS: 'LOAD_STUDENT_STATUS_SUCCESS',
    LOAD_STUDENT_STATUS_FAILURE: 'LOAD_STUDENT_STATUS_FAILURE',

    // Loading supported currencies
    LOAD_SUPPORTED_CURRENCIES_REQUEST: 'LOAD_SUPPORTED_CURRENCIES_REQUEST',
    LOAD_SUPPORTED_CURRENCIES_SUCCESS: 'LOAD_SUPPORTED_CURRENCIES_SUCCESS',
    LOAD_SUPPORTED_CURRENCIES_FAILURE: 'LOAD_SUPPORTED_CURRENCIES_FAILURE',

    // Debug status
    SET_DEBUG_STATUS: 'SET_DEBUG_STATUS'
}


// WEBPACK FOOTER //
// ./src/redux/constants/general.constants.js